// extracted by mini-css-extract-plugin
export var errorIcon = "_kd-1";
export var nameLogo = "_kd-0";